import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Grid, Modal, Paper } from '@mui/material';
import UserAvatarComponent from 'components/UserAvatarComponent';
import { convertDateAndTime, processToUpper, timeDiffer, urlify } from 'Helpers';
import { socket } from 'socket';
import VoiceViewer from 'components/modals/VoiceViewer';

const MiniPostCard = ({ item, type }) => {
    const [showMore, setShowMore] = useState(false);
    const [reactCount, setReactCount] = useState(type === 'news' ? parseInt(item.newsReactCount) : parseInt(item.noticeReactCount));
    const [OpenViewModal, setOpenViewModal] = useState(false);

    useEffect(() => {
        listen_to_channel();
    }, []);

    function listen_to_channel() {
        socket.on(`${type}_mini_react_added`, (id) => {
            if (id == item[`${type}_id`]) {
                setReactCount((prev) => prev + 1);
            }
        });
        socket.on(`${type}_mini_react_removed`, (id) => {
            if (id == item[`${type}_id`]) {
                setReactCount((prev) => prev - 1);
            }
        });
    }
    return (
        <>
            <Paper
                elevation={0}
                sx={{
                    marginBottom: '16px',
                    padding: '20px',
                    borderRadius: '12px',
                    border: '1px solid #1E7C8840',
                    backgroundColor: '#ffffff',
                    transition: 'all 0.2s ease-in-out',
                    cursor: 'pointer'
                }}
            >
                <Box
                    display="flex"
                    gap="12px"
                    sx={{
                        position: 'relative',
                        alignItems: { lg: 'flex-start', md: 'flex-start', xs: 'flex-start' },
                        marginBottom: '16px'
                    }}
                >
                    <Box sx={{ flexShrink: 0 }}>
                        <UserAvatarComponent userData={item.user} />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', width: '100%', gap: '5px' }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    fontSize: '15px',
                                    fontWeight: '600',
                                    color: '#1a1a1a',
                                    marginBottom: '4px',
                                    lineHeight: '1.2'
                                }}
                            >
                                {`${item.user?.first_name} ${item.user?.last_name}`}
                            </Typography>
                            <Box display="flex" sx={{ flexDirection: 'column', gap: '2px' }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '13px',
                                        color: 'rgba(0, 0, 0, 0.6)'
                                    }}
                                >
                                    {item.user?.job_title[0].title ?? 'N/A'}
                                </Typography>
                            </Box>
                        </Box>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'rgba(0, 0, 0, 0.5)',
                                fontSize: '12px',
                                fontWeight: '400'
                            }}
                        >
                            {convertDateAndTime(item.createdAt, false)}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ marginBottom: '16px' }}>
                    {urlify(item.plain_text_body).length > 35 ? (
                        <Box>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontSize: '14px',
                                    lineHeight: '1.5',
                                    color: '#333'
                                }}
                            >
                                {showMore ? urlify(item.plain_text_body) : `${urlify(item.plain_text_body).substring(0, 100)}...`}
                                {!showMore ? (
                                    <Button
                                        sx={{
                                            fontSize: '13px',
                                            textTransform: 'none',
                                            padding: 0,
                                            minWidth: 'auto',
                                            marginLeft: '4px',
                                            color: '#1E7C88'
                                        }}
                                        onClick={() => setShowMore(true)}
                                    >
                                        View more
                                    </Button>
                                ) : (
                                    <Button
                                        sx={{
                                            fontSize: '13px',
                                            textTransform: 'none',
                                            padding: 0,
                                            minWidth: 'auto',
                                            marginLeft: '4px',
                                            color: '#1E7C88'
                                        }}
                                        onClick={() => setShowMore(false)}
                                    >
                                        View less
                                    </Button>
                                )}
                            </Typography>
                        </Box>
                    ) : (
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: '14px',
                                lineHeight: '1.5',
                                color: '#333'
                            }}
                        >
                            {urlify(item.plain_text_body)}
                        </Typography>
                    )}
                </Box>

                <Box
                    display="flex"
                    alignItems="center"
                    gap="16px"
                    sx={{
                        paddingTop: '12px'
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '13px',
                            fontWeight: '500',
                            color: '#1E7C88',
                            marginLeft: 'auto',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            cursor: 'pointer',
                            border: '1px solid #1E7C88',
                            borderRadius: '50px',
                            backgroundColor: 'rgba(30, 124, 136, 0.08)',
                            padding: '4px 12px',
                            '&:hover': {
                                color: '#1E7C88',
                                backgroundColor: 'rgba(30, 124, 136, 0.03)',
                                borderColor: '#1E7C88',
                                transition: 'all 0.2s ease-in-out'
                            }
                        }}
                        onClick={() => setOpenViewModal(true)}
                    >
                        View {type === 'news' ? 'News' : 'Notice'}
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7 17L17 7M17 7H7M17 7V17"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </Typography>
                </Box>
            </Paper>

            {OpenViewModal && (
                <Modal
                    keepMounted
                    open={OpenViewModal}
                    onClose={() => setOpenViewModal(false)}
                    aria-labelledby="keep-mounted-modal-title"
                    aria-describedby="keep-mounted-modal-description"
                >
                    <Grid
                        item
                        sm={12}
                        container
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ width: '100vw', height: '100vh', paddingX: '1.5rem' }}
                    >
                        <VoiceViewer post={item} setOpenViewer={setOpenViewModal} model={type} type="view" />
                    </Grid>
                </Modal>
            )}
        </>
    );
};

export default MiniPostCard;
